import React from 'react';

class LeaguesDropdown extends React.Component {

  constructor(props) {
		super(props);
		this.leagueChange = this.leagueChange.bind(this);
		this.createSelectItem = this.createSelectItem.bind(this);
	}

	leagueChange(event) {
		var leagueId = event.target.value;
		this.props.leagueChange(leagueId);
	}

	render() {
		//console.log('LeaguesDropdown: render')
		return (
			<select className="form-control" value={this.props.value} onChange={this.leagueChange} >
				{this.createOption0(this.props.bOption0)}
				{this.props.leagues.map(this.createSelectItem)}
			</select>
		);
	}

	createOption0(bOption0) {
		if(bOption0) {
			return (
				<option value={0} key={'opt0'} disabled hidden>Choisir une ligue...</option>
			);
		} else {
			return;
		}
	}

	createSelectItem(league) {
		return (
			<option value={league._id} key={league._id}>{league.name}</option>
		);
	}

}

export default LeaguesDropdown;